import { useMsal } from '@azure/msal-react'
import { createContext, useContext, useEffect, useRef, useState } from 'react'
import { USER_ROLE } from  '@src/utils/constants.ts'

interface UserData {
  currentUser: User | null
  isUserLoading: boolean
}

interface User {
  id: string
  name: string
  userRole: string[]
  accountName: string
  email: string,
  isParent: boolean
  accessInfo: string[]
  roles: string[]
}

const UserContext = createContext<UserData | null>(null)

export const useUserContext = () => {
  return useContext(UserContext)
}

export const UserProvider = ({ children, dataProvider, userId }: any) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null)
  const [isUserLoading, setIsUserLoading] = useState(true)
  const isFetching = useRef(false)
  const { instance } = useMsal()

  useEffect(() => {
    const fetchData = async () => {
      if (isFetching.current) return // Return early if a fetch is ongoing

      try {
        isFetching.current = true
        if (dataProvider) {
          if (userId) {
            const response = await dataProvider.getOne('User', {
              id: userId,
            })
            // Check if there is at least one item in the response
            if (response.data) {
              const data = response.data
              const userDataSubset = {
                id: data.id,
                name: data.first_name + ' ' + data.last_name,
                userRole: data.user_role,
                roles: data.roles,
                accountName: data.account_name,
                email: data.primary_email,
                isParent: data.roles.includes(USER_ROLE.PARENT),
                accessInfo: data.access_info
                // associated_users: data.associated_users,
                // associated_learners: data.associated_learners
              }
              setCurrentUser(userDataSubset)
            } else {
              // Handle the case where there are no items in the response
              console.log('No user data found')
            }
          }
          setIsUserLoading(false)
        }
      } catch (error: any) {
        // Handle error
        if (error.message && error.message == 'Sorry, Your account is not active, please contact your account administrator') {
          ['userEmail', 'msalB2CId', 'UserId', 'AccountId', 'msalClientId', 'msalClientUrl', 'apiUrl'].forEach((key) => localStorage.removeItem(key))
          // issue in msal, sometimes this below status is not cleared so manually clearing the msal.interaction.status
          sessionStorage.removeItem('msal.interaction.status')
          // alert('Sorry, Your account is not active, please contact your account administrator');
          instance.logoutRedirect()
        }
      } finally {
        isFetching.current = false
      }
    }
    fetchData()
  }, [dataProvider, userId])

  return <UserContext.Provider value={{ currentUser, isUserLoading }}>{children}</UserContext.Provider>
}
